import header from '~/mixins/header.js'
import { getDeviceSize } from '~/utils/device'
import debounce from 'lodash/debounce'

export default {
  mixins: [header],

  props: {
    label: {
      type: String,
      required: true,
    },
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.resize)
      window.dispatchEvent(new Event('resize'))
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  },

  methods: {
    resize(e) {
      this.resizeDebounce(e, this)
    },

    resizeDebounce: debounce((e, self) => {
      const deviceSize = getDeviceSize()
      const isDesktop = /desktop(-m|-l|-xl)/i.test(deviceSize)
      if (isDesktop) self.closeSidebar(e)
    }, 100),

    closeSideBarAndNavigateTo(value) {
      const hasHttpInValue = value.match(/^https?/i)

      if (hasHttpInValue) {
        window.location = value

        return
      }

      this.closeSidebar(new Event('click'))

      if (value !== this.$route.path) this.$router.push({ path: value })
    },
  },
}
